module.exports = __webpack_public_path__ + "static/media/raasIcon.7d698679.svg";